import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Loading } from 'src/components/shared/Loading';
import { LoadingFailed } from 'src/components/shared/LoadingFailed';
import { DialogRoute } from 'src/components/shared/routes/DialogRoute';
import { RootState } from 'src/features';
import { actions } from 'src/features/fortune';
import { FortunePageLayout } from '../common/FortunePageLayout';
import { FortuneHistoryDetailDialog } from './detail/FortuneHistoryDetailDialog';
import { FortuneExchangeHistoryContent } from './FortuneExchangeHistoryContent';

export const FortuneExchangeHistory = () => {
  const { t } = useTranslation(['fortune', 'translation']);
  const { point, exchangeHistory } = useSelector((state: RootState) => state.fortune);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getFortuneExchangeHistory());
  }, [dispatch]);

  if (point?.state !== 'ok') {
    return <Redirect to="/players/fortune/home" />;
  }

  return (
    <>
      <FortunePageLayout
        title={t('exchange_histories')}
        backLabel={t('translation:aria_button_back_to_previous')}
        hintLabel={t('aria_help')}
      >
        {(() => {
          switch (exchangeHistory?.state) {
            case 'pending':
              return <Loading />;
            case 'ok':
              const histories = exchangeHistory.result.itemHistories;
              const totalGotPoint = exchangeHistory.result.totalGotPoint;
              return (
                <FortuneExchangeHistoryContent
                  histories={histories}
                  totalGotPoint={totalGotPoint}
                />
              );
            case 'error':
              return <LoadingFailed error={exchangeHistory.error} />;
            default:
              return <></>;
          }
        })()}
      </FortunePageLayout>

      <DialogRoute path="/players/fortune/exchange-history/detail/:index">
        <FortuneHistoryDetailDialog />
      </DialogRoute>
    </>
  );
};
